import { useEffect, useRef, useState, useTransition } from 'react';

import { listSessions } from '~modules/journal/api';
import { JournalManualDto } from '~modules/journal/model';

export function useListSessions() {
	const [active, setActive] = useState<boolean>(true);
	const [list, setList] = useState<JournalManualDto[]>([]);
	const [pending, startTransition] = useTransition();
	const isFirstRender = useRef(true);

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;
			startTransition(async () => {
				const data = await listSessions(active);
				setList(data);
			});
		}
	}, [active]);

	return { list, pending, active, setActive };
}
